 export const teachers = [
  {
    id: 1,
    name: "Enea Gega",
    birthyear: 1994,
    rating: 0,
    gender: "Male",
  },
  {
    id: 2,
    name: "Sabrina Bush",
    birthyear: 1999,
    rating: 5,
    gender: "Female"
  },
  {
    id: 3,
    name: "Klemens Riska",
    birthyear: 1994,
    rating: 0,
    gender: "Male"
  },
  {
    id: 4,
    name: "Jimmy Neutron",
    birthyear: 1998,
    rating: 0,
    gender: "Male"
  },
  {
    id: 5,
    name: "Lizzie Rossie",
    birthyear: 1978,
    rating: 0,
    gender: "Female"
  },
  {
    id: 6,
    name: "Johny Noble",
    birthyear: 1984,
    rating: 0,
    gender: "Male"
  },
  {
    id: 7,
    name: "Vincent Blair",
    birthyear: 1964,
    rating: 0,
    gender: "Male"
  },
  {
    id: 8,
    name: "Serena Modi",
    birthyear: 1984,
    rating: 0,
    gender: "Female"
  },
  {
    id: 9,
    name: "Mahmoud Al Khaliji",
    birthyear: 1964,
    rating: 0,
    gender: "Male"
  },
  {
    id: 10,
    name: "Victor Wang",
    birthyear: 2000,
    rating: 0,
    gender: "Male"
  },
];
